import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { v1 as uuid } from 'uuid';
import { Tooltip } from '@material-ui/core';
import MDIcon from '../../../shared/components/MDIcon';
import { REPORT_CARD_STATUS } from '../../../shared/utils/constants';
import {
  dynamicSortAsc,
  dynamicSortDesc,
} from '../../../shared/utils/smartutils';

const LeftContainer = ({
  t,
  closure,
  schoolClasses,
  selectedSchoolClass,
  changeSelectedSchoolClass,
}) => {
  const [isSortAscending, setIsSortAscending] = useState(true);
  const getBg = (status) => {
    switch (status) {
      case REPORT_CARD_STATUS.RELEASED:
        return 'bg-success';
      case REPORT_CARD_STATUS.FINISHED:
        return 'bg-primary';
      case REPORT_CARD_STATUS.PENDING:
        return 'bg-danger';
      case REPORT_CARD_STATUS.PARTIAL:
        return 'bg-warning';
      default:
        return 'default';
    }
  };

  const reorder = () => {
    if (isSortAscending) {
      schoolClasses.sort(dynamicSortDesc('name'));
    } else {
      schoolClasses.sort(dynamicSortAsc('name'));
    }
    setIsSortAscending(!isSortAscending);
  };

  useEffect(() => {
    reorder();
  }, [schoolClasses]);

  const buildItems = () => {
    return schoolClasses.map((item) => (
      <Fragment key={uuid()}>
        <button
          type="button"
          className={`item ${
            selectedSchoolClass.id === item.id ? 'selected' : ''
          }`}
          data-toggle="tooltip"
          title={item.name}
          onClick={() => changeSelectedSchoolClass(item)}
        >
          <span className="label">{item.name}</span>
          <span className={`pill ${getBg(item.status)}`}>
            {t(`report-card-status.${item.status}`)}
          </span>
        </button>
        <div className="divider" />
      </Fragment>
    ));
  };

  return (
    <div className="course-container">
      <div className="field">
        <span>{t('general.course')}</span>
        <span>{closure.course.name}</span>
      </div>
      <div className="field">
        <span>{t('general.school-term')}</span>
        <span>{closure.period.name}</span>
      </div>
      <div className="field">
        <span>{t('general.cycle')}</span>
        <span>{closure.cycleNumber}</span>
      </div>
      <div className="field-with-button">
        <span>{t('general.school-classes')}</span>
        <Tooltip
          title={
            isSortAscending ? t('general.ascending') : t('general.descending')
          }
        >
          <button type="button" onClick={reorder}>
            {isSortAscending ? (
              <MDIcon iconPath="mdiSortVariant" />
            ) : (
              <MDIcon iconPath="mdiSortReverseVariant" />
            )}
          </button>
        </Tooltip>
      </div>
      <div className="list-group">
        {schoolClasses.length ? buildItems() : null}
      </div>
    </div>
  );
};

LeftContainer.propTypes = {
  t: PropTypes.func.isRequired,
  closure: PropTypes.shape(PropTypes.shape).isRequired,
  selectedSchoolClass: PropTypes.shape({
    id: PropTypes.number,
  }),
  schoolClasses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      status: PropTypes.string,
    })
  ).isRequired,
  changeSelectedSchoolClass: PropTypes.func.isRequired,
};

LeftContainer.defaultProps = {
  selectedSchoolClass: PropTypes.shape({
    id: 0,
  }),
};

export default withTranslation('common')(LeftContainer);
